import GenericRequest, { METHOD_PUT } from '../../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';

export default class SendMessageRequest extends GenericRequest {

    message;
    _companyTargetId;
    parent_message_id;
    query_ids;

    constructor(message, companyTargetId, parent_message_id = null, queryIds = {}) {
        super(METHOD_PUT, ApiEndpoints.MESSAGES);

        this.message = message;
        this._companyTargetId = companyTargetId;
        this.parent_message_id = parent_message_id;
        this.query_ids = queryIds;
    }

    overrideRequest() {
        let request = {};
        if ( this.message ) request.message = this.message;
        if ( this._companyTargetId ) request.company_target_id = this._companyTargetId;
        if ( this.parent_message_id ) request.parent_message_id = this.parent_message_id;

        if ( this.query_ids.document_id ) request.document_id = this.query_ids.document_id;
        if ( this.query_ids.construction_id ) request.construction_id = this.query_ids.construction_id;
        if ( this.query_ids.worker_id ) request.worker_id = this.query_ids.worker_id;
        if ( this.query_ids.machine_id ) request.machine_id = this.query_ids.machine_id;
        if ( this.query_ids.company_id ) request.company_id = this.query_ids.company_id;

        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/to-refactor/shared/ws/SendMessageRequest.js